import { logToConsole } from './consoleLogger';

export type Logger = {
  debug(message: string, ...args: any[]): void;
  info(message: string, ...args: any[]): void;
  warn(message: string, ...args: any[]): void;
  error(message: string, ...args: any[]): void;
};

const loggerCache = new Map<string, Logger>();

export function getLogger(name: string): Logger {
  let logger = loggerCache.get(name);
  if (!logger) {
    logger = {
      debug(message: string, ...args: any[]) {
        logToConsole({ loggerName: name, logLevel: 'DEBUG', message, args });
      },
      info(message: string, ...args: any[]) {
        logToConsole({ loggerName: name, logLevel: 'INFO', message, args });
      },
      warn(message: string, ...args: any[]) {
        logToConsole({ loggerName: name, logLevel: 'WARN', message, args });
      },
      error(message: string, ...args: any[]) {
        logToConsole({ loggerName: name, logLevel: 'ERROR', message, args });
      }
    };
    loggerCache.set(name, logger);
  }
  return logger;
}
